import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'components';
import styles from './ActionsListMenu.scss';

const ActionsListMenu = ({ actions, close, comment }) => {

    const handleActionClick = (cb) => {
        cb(comment.id);
        close();
    };

    return (
        <div
            className={styles.container}
            data-testid='dots-actions-menu__list'
        >
            {
                actions.map(action =>
                    comment.allowedActions.includes(action.type) &&
                        <div
                            key={action.type}
                            onClick={() => handleActionClick(action.callback)}
                            className={classnames(
                                styles.action,
                                styles[action.type]
                            )}
                            data-testid={`dots-actions-menu__list-item--${action.type}`}
                        >
                            <Icon
                                name={action.icon}
                            />

                            <span>{ action.label }</span>
                        </div>
                )
            }
        </div>
    )
}

ActionsListMenu.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string,
        label: PropTypes.string,
        icon: PropTypes.string,
        callback: PropTypes.func
    })),
    close: PropTypes.func.isRequired,
    comment: PropTypes.shape({
        author: PropTypes.shape({
            email: PropTypes.string,
            name: PropTypes.string,
        }),
        createdAt: PropTypes.string,
        content: PropTypes.string,
        userAdmin: PropTypes.bool,
        allowedActions: PropTypes.arrayOf(PropTypes.string)
    }).isRequired
};

ActionsListMenu.defaultProps = {
    actions: []
};

export default ActionsListMenu;

